const config = {
  TASKS_API_URL: process.env.REACT_APP_TASKS_API_URL || 'https://fe-api.smartera.uk',

  // Specific endpoints
  get TRACK_TICKET_URL() { return `${this.TASKS_API_URL}/tasks/track-by-email`; },
  get SUBMIT_TICKET_URL() { return `${this.TASKS_API_URL}/tasks/submit-guest-ticket`; },

  // Support endpoints
  get MY_TICKETS_URL() { return `${this.TASKS_API_URL}/tasks/my-tickets`; },
  get SUBMIT_CUSTOMER_TICKET_URL() { return `${this.TASKS_API_URL}/tasks/submit-customer-ticket`; },
  get PROJECTS_URL() { return `${this.TASKS_API_URL}/projects`; },

  // Debug URLs
  get DEBUG_TEST_URL() { return `${this.TASKS_API_URL}/tasks/test`; },
  get DEBUG_INFO_URL() { return `${this.TASKS_API_URL}/debug/info`; },
  get WALLET_API_URL() { return `${this.TASKS_API_URL}/wallet`; },

  // Authentication
  get LOGIN() { return `${this.TASKS_API_URL}/auth/login`; },
  get PROFILE() { return `${this.TASKS_API_URL}/auth/profile`; },
  get CHANGE_PASSWORD() { return `${this.TASKS_API_URL}/auth/change-password`; },

  // Customer Portal Resources
  get CONTRACTS_URL() { return `${this.TASKS_API_URL}/contracts`; },
  get HOSTING_URL() { return `${this.TASKS_API_URL}/hosting`; },
};

export default config;
